import React, { useState, Fragment, useEffect, useRef } from 'react';
import { useFormContext, Controller, ErrorMessage } from 'react-hook-form';
import { useStyle } from './style';
import {
    Paper, Grid, TextField, FormControlLabel, Tooltip, Typography, FormControl, RadioGroup, Radio,
    Select, MenuItem, InputLabel, Checkbox, FormLabel
} from '@material-ui/core';
import { masterData } from "./data";
import HelpOutlinedIcon from '@material-ui/icons/HelpOutlined';
import errormesages from './errormessages';
import { isMobileOnly } from 'react-device-detect';
export default function EirInstallationInfo(props) {
    const { errors, control } = useFormContext();
    const { validation } = errormesages;
    const classes = useStyle();
    const landlineInputRef = useRef();
    const movingBroadbandInputRef = useRef();
    const broadbandProviderInputRef = useRef();
    const prefixInputRef = useRef();
    const [areaCode, setAreaCode] = useState(null);
    const landlineNumberInputRef = useRef();
    const accountNumberInputRef = useRef();
    const otherProviderInputRef = useRef();
    const monitoredAlarmInputRef = useRef();
    const [showProvider, setShowProvider] = useState(false);
    const [showLandline, setShowLandline] = useState(false);
    const [showAccountNo, setShowAccountNo] = useState(false);
    const [showOtherProvider, setOtherProvider] = useState(false);
    const [showMonitorAlarm, setShowMonitorAlarm] = useState(false);
    const [txtAccountNo, setTxtAccountNo] = useState('UAN (Universal Account Number');
    const [txtMonitorTop, setTxtMonitorTop] = useState('Our online home phone service works through your broadband modem and not a separate landline. It requires a power supply.');
    const [txtMonitorMiddle, setTxtMonitorMiddle] = useState('Monitored or panic alarms that require a connection to a landline are NOT supported.');
    const [txtMonitorBottom, setTxtMonitorBottom] = useState('If you have a monitored or panic alarm and would like to get a traditional landline connection with broadband, chat to one of our webchat agents to place your order.');
    const [showTxtMonitor, setShowTxtMonitor] = useState(false);
    const resetAll = () => {
        setShowAccountNo(false);
        setOtherProvider(false);
        setShowMonitorAlarm(false);
        setShowTxtMonitor(false);
        setTxtAccountNo('UAN (Universal Account Number');
        props.setExistingProvider(null);
    }
    const changeProvider = value => {
        if (value === 'VIRGIN MEDIA') {
            setShowAccountNo(true);
            setTxtAccountNo("Virgin Media Account Number");
            setOtherProvider(false);
            setShowMonitorAlarm(false);
            setShowTxtMonitor(false);
        }
        else if (value === 'MAGNET') {
            setShowAccountNo(true);
            setTxtAccountNo("Magnet Account Number");
            setOtherProvider(false);
            setShowMonitorAlarm(false);
            setShowTxtMonitor(false);
        }
        else if (value === 'OTHER') {
            setShowAccountNo(true);
            setTxtAccountNo("UAN (Universal Account Number)");
            setOtherProvider(true);
            setShowMonitorAlarm(true);
        } else {
            setShowAccountNo(true);
            setTxtAccountNo("UAN (Universal Account Number)");
            setOtherProvider(false);
            setShowMonitorAlarm(true);
        }
        props.setExistingProvider(value);
    };

    useEffect(() => {
        if (!areaCode) {
            let areaCodes = '/json/areacodes.txt';
            fetch(areaCodes)
                .then((response) => {
                    return response.json()
                })
                .then((data) => {
                    setAreaCode(data.areacodes);
                })
                .catch((err) => {
                    console.log(">>>>>>>Error in fetching the areacodes - ", err);
                })
        }
    });
    return (
        <Fragment>
            <Grid item sm={12} className={(isMobileOnly) ? classes.personalPaddingInstallation : classes.personalPadding}>
                <Paper className={classes.contactPaper} variant='elevation' elevation={4}>
                    <Grid container>
                        <Grid item sm={6}>
                            <h2 className={classes.contactTxt}>
                                Installation Details
                            </h2>
                        </Grid>
                        <Grid item sm={6}>
                            <Typography className={classes.reqTextInstallation}><span style={{ color: 'red', textAlign: 'right' }} >*</span> Required Fields</Typography>
                        </Grid>
                        <Grid container sm={12}>
                            <Grid item sm={6} className={classes.paddingRightItem}>
                                <Grid>
                                    <Typography className={classes.personalLabel}> Do you have a home landline? <span style={{ color: 'red', textAlign: 'center' }} >*</span></Typography>
                                </Grid>
                                <FormControl color="secondary" variant="outlined" fullWidth size="small" className={classes.dropDownMinWidth}>
                                    <Controller
                                        control={control}
                                        name="landline"
                                        id="landline"
                                        inputRef={landlineInputRef}
                                        defaultValue=""
                                        rules={{ required: { value: true, message: validation.landLineRequired } }}
                                        error={Boolean(errors.landline)}
                                        onFocus={() => {
                                            landlineInputRef.current.focus();
                                        }}
                                        as={
                                            <RadioGroup aria-label="landline" name="landline" id='landline'
                                                className={classes.radioButtom}>
                                                <Grid container>
                                                    <Grid item>
                                                        <FormControlLabel value="yes" control={<Radio />} label="Yes" className={classes.personalLabel} />
                                                    </Grid>
                                                    <Grid item>
                                                        <FormControlLabel value="no" control={<Radio />} label="No" className={classes.personalLabel} />
                                                    </Grid>
                                                </Grid>
                                            </RadioGroup>
                                        }
                                        onChange={([event]) => {
                                            if (event.target.value === "yes")
                                                setShowLandline(true);
                                            else {
                                                props.setExistingProvider(null);
                                                setShowLandline(false);
                                                if(showProvider)
                                                    setShowProvider(true);
                                                else
                                                    setShowProvider(false);
                                            }
                                            return event.target.value;
                                        }}
                                    />

                                    <ErrorMessage errors={errors} name='landline'>
                                        {({ message }) => <p className={classes.errorMessageGender}>{message}</p>}
                                    </ErrorMessage>
                                </FormControl>
                            </Grid>
                            <Grid item sm={6} className={classes.paddingLeftItem}>
                                <Grid>
                                    <Typography className={classes.personalLabel}>Are you moving from another broadband provider?<span style={{ color: 'red', textAlign: 'center' }} > *</span></Typography>
                                </Grid>
                                <FormControl color="secondary" variant="outlined" fullWidth size="small" className={classes.dropDownMinWidth}>
                                    <Controller
                                        control={control}
                                        name="movingBroadband"
                                        id="movingBroadband"
                                        inputRef={movingBroadbandInputRef}
                                        defaultValue=""
                                        rules={{ required: { value: true, message: validation.movingBroadbandRequired } }}
                                        error={Boolean(errors.movingBroadband)}
                                        onFocus={() => {
                                            movingBroadbandInputRef.current.focus();
                                        }}
                                        as={
                                            <RadioGroup aria-label="movingBroadband" name="movingBroadband" id='movingBroadband'
                                                className={classes.radioButtom}>
                                                <Grid container>
                                                    <Grid item>
                                                        <FormControlLabel value="yes" control={<Radio />} label="Yes" className={classes.personalLabel} />
                                                    </Grid>
                                                    <Grid item>
                                                        <FormControlLabel value="no" control={<Radio />} label="No" className={classes.personalLabel} />
                                                    </Grid>
                                                </Grid>
                                            </RadioGroup>
                                        }
                                        onChange={([event]) => {
                                            if (event.target.value === "yes")
                                                setShowProvider(true);
                                            else {
                                                resetAll();
                                                setShowProvider(false);
                                                setShowTxtMonitor(false);
                                                if(showLandline)
                                                setShowLandline(true);
                                                else
                                                setShowLandline(false);
                                            }
                                            return event.target.value;
                                        }}
                                    />
                                    <ErrorMessage errors={errors} name='movingBroadband'>
                                        {({ message }) => <p className={classes.errorMessageGender}>{message}</p>}
                                    </ErrorMessage>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid item sm={6}>
                            <Typography className={classes.reqTextInstallationMob}><span style={{ color: 'red', textAlign: 'right' }} >*</span> Required Fields</Typography>
                        </Grid>
                        <Grid container sm={12} className={classes.paddingTopMiddle}>
                            {showProvider || showLandline ?
                                <Grid container
                                >
                                    {showProvider && showLandline?
                                <Grid container sm={6} xs={12}>
                                        <Grid item sm={2} xs={4} spacing={3} className={classes.accountPrefix}>
                                        <FormControl variant="outlined" fullWidth size="small" color="secondary" className={classes.dropDownMinWidth}>
                                            <InputLabel required
                                                error={Boolean(errors.prefix)}
                                            >Prefix</InputLabel>
                                            <Controller
                                                control={control}
                                                name="prefix"
                                                id="prefix"
                                                inputRef={prefixInputRef}
                                                error={Boolean(errors.prefix)}
                                                onFocus={() => {
                                                    prefixInputRef.current.focus();
                                                }}
                                                rules={{ required: { value: true, message: validation.invalidAccount } }}
                                                as={
                                                    <Select
                                                        id="prefix"
                                                        label="Prefix"
                                                    >
                                                        {areaCode ? areaCode.map((code) =>
                                                            <MenuItem key={code.code} value={code.code} className={classes.selectLabel}>
                                                                {code.code}
                                                            </MenuItem>
                                                        ) : ''}
                                                    </Select>
                                                }
                                                onChange={([event]) => {
                                                    return event.target.value;
                                                }}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item sm={10} xs={8} className={classes.paddingRightItem}>
                                    <Controller
                                        as={<TextField inputRef={landlineNumberInputRef} color="secondary" />}
                                        control={control}
                                        fullWidth
                                        id="landlineNumber"
                                        name="landlineNumber"
                                        label="Landline number"
                                        variant="outlined"
                                        size="small"
                                        inputProps={{ maxLength: 7 }}
                                        error={Boolean(errors.landlineNumber)}
                                        onFocus={() => {
                                            landlineNumberInputRef.current.focus();
                                        }}
                                        required
                                        rules={{
                                            required: { value: true, message: validation.landlineNumberRequired },
                                            pattern: { value: /^[0-9]*$/, message: validation.landLinePattern },
                                            minLength: { value: 5, message: validation.landLinePatternMinLength }
                                        }}
                                    />
                                    {errors.prefix ?
                                        <Grid className={classes.errorMessageHeight}>
                                            <ErrorMessage errors={errors} name='prefix'>
                                                {({ message }) => <p className={classes.errorMessage}>{message}</p>}
                                            </ErrorMessage>
                                        </Grid>
                                        :
                                        <Grid className={classes.errorMessageHeight}>
                                            <ErrorMessage errors={errors} name="landlineNumber">
                                                {({ message }) => <p className={classes.errorMessage}>{message}</p>}
                                            </ErrorMessage>
                                        </Grid>
                                    }
                                </Grid>
                                </Grid>
                                    :''}
                                    
                                    
                                    {showProvider ?
                                        <Grid item sm={5} xs={12} className={showLandline ? classes.paddingLeftItem : classes.paddingRightItem}>
                                            <FormControl color="secondary" variant="outlined" fullWidth size="small" className={classes.dropDownMinWidth}>
                                                <InputLabel required
                                                >Current Broadband Provider</InputLabel>
                                                <Controller
                                                    control={control}
                                                    name="broadbandProvider"
                                                    id="broadbandProvider"
                                                    inputRef={broadbandProviderInputRef}
                                                    defaultValue=""
                                                    rules={{ required: { value: true, message: validation.broadbandProviderRequired } }}
                                                    error={Boolean(errors.broadbandProvider)}
                                                    onFocus={() => {
                                                        broadbandProviderInputRef.current.focus();
                                                    }}
                                                    as={
                                                        <Select
                                                            id='broadbandProvider'
                                                            label="Current Broadband Provider"
                                                        >
                                                            {masterData.filter(masterData => masterData.id === 'provider').map((data) =>
                                                                data.value.map((val) =>
                                                                (
                                                                    <MenuItem key={val.value} value={val.value} className={classes.selectLabel}>
                                                                        {val.label}
                                                                    </MenuItem>
                                                                ))
                                                            )}
                                                        </Select>
                                                    }
                                                    onChange={([event]) => {
                                                        changeProvider(event.target.value);
                                                        return event.target.value;
                                                    }}
                                                />
                                                <Grid className={classes.errorMessageHeight}>
                                                    <ErrorMessage errors={errors} name='broadbandProvider'>
                                                        {({ message }) => <p className={classes.errorMessage}>{message}</p>}
                                                    </ErrorMessage>
                                                </Grid>
                                            </FormControl>
                                        </Grid>
                                        : ''}
                                </Grid>
                                : ''}
                        </Grid>
                        <Grid container sm={12}>
                            {showAccountNo ?
                                <Grid item sm={6} xs={12} className={classes.paddingRightItem}>
                                    <Controller
                                        as={<TextField inputRef={accountNumberInputRef} color="secondary" />}
                                        control={control}
                                        fullWidth
                                        id="accountNumber"
                                        name="accountNumber"
                                        label={txtAccountNo}
                                        variant="outlined"
                                        size="small"
                                        error={Boolean(errors.accountNumber)}
                                        required
                                        onFocus={() => {
                                            accountNumberInputRef.current.focus();
                                        }}
                                        rules={{
                                            required: { value: true, message: validation.accountNumberRequired },
                                        }}
                                    />
                                    <Grid className={classes.errorMessageHeight}>
                                        <ErrorMessage errors={errors} name="accountNumber">
                                            {({ message }) => <p className={classes.errorMessage}>{message}</p>}
                                        </ErrorMessage>
                                    </Grid>
                                </Grid>
                                : ''}

                            {showOtherProvider ?
                                <Grid item sm={6} xs={12} className={classes.paddingLeftItem}>
                                    <Controller
                                        as={<TextField inputRef={otherProviderInputRef} color="secondary" />}
                                        control={control}
                                        fullWidth
                                        id="otherProvider"
                                        name="otherProvider"
                                        label="Other Provider"
                                        variant="outlined"
                                        size="small"
                                        error={Boolean(errors.otherProvider)}
                                        onFocus={() => {
                                            otherProviderInputRef.current.focus();
                                        }}
                                        required
                                        rules={{
                                            required: { value: true, message: validation.otherProviderRequired },
                                        }}
                                    />
                                    <Grid className={classes.errorMessageHeight}>
                                        <ErrorMessage errors={errors} name="otherProvider">
                                            {({ message }) => <p className={classes.errorMessage}>{message}</p>}
                                        </ErrorMessage>
                                    </Grid>
                                </Grid>
                                : ''}
                        </Grid>
                        <Grid container sm={12}>
                            {showMonitorAlarm ?
                                <Grid item sm={12}>
                                    <Grid container>
                                        <Grid item>
                                            <Typography className={classes.personalLabel}>Do you have a monitored alarm or any service that is reliant on your existing landline?<span style={{ color: 'red', textAlign: 'center' }} > *</span></Typography>
                                        </Grid>

                                    </Grid>
                                    <FormControl color="secondary" variant="outlined" fullWidth size="small" className={classes.dropDownMinWidth}>
                                        <Controller
                                            control={control}
                                            name="monitoredAlarm"
                                            id="monitoredAlarm"
                                            inputRef={monitoredAlarmInputRef}
                                            defaultValue=""
                                            rules={{ required: { value: true, message: validation.monitoredAlarmRequired } }}
                                            error={Boolean(errors.monitoredAlarm)}
                                            onFocus={() => {
                                                monitoredAlarmInputRef.current.focus();
                                            }}
                                            as={
                                                <RadioGroup aria-label="monitoredAlarm" name="monitoredAlarm" id='monitoredAlarm'
                                                    className={classes.radioButtom}>
                                                    <Grid container>
                                                        <Grid item>
                                                            <FormControlLabel value="yes" control={<Radio />} label="Yes" className={classes.personalLabel} />
                                                        </Grid>
                                                        <Grid item>
                                                            <FormControlLabel value="no" control={<Radio />} label="No" className={classes.personalLabel} />
                                                        </Grid>
                                                    </Grid>
                                                </RadioGroup>
                                            }
                                            onChange={([event]) => {
                                                if (event.target.value === "yes")
                                                    setShowTxtMonitor(true);
                                                else {
                                                    setShowTxtMonitor(false);
                                                }
                                                return event.target.value;
                                            }}
                                        />
                                        <ErrorMessage errors={errors} name='monitoredAlarm'>
                                            {({ message }) => <p className={classes.errorMessageGender}>{message}</p>}
                                        </ErrorMessage>
                                    </FormControl>
                                    <Grid item sm={5}>

                                    </Grid>
                                </Grid>
                                : ''}
                        </Grid>
                        {showTxtMonitor ?
                            <Grid container sm={12} xs={12}>
                                <Grid item sm={12}>
                                    <Typography className={classes.installationAgreementLabel}>
                                        {txtMonitorTop}
                                    </Typography>
                                </Grid>
                                <Grid item sm={12}>
                                    <Typography className={classes.personalLabel}>
                                        {txtMonitorMiddle}
                                    </Typography>
                                </Grid>
                                <Grid item sm={12}>
                                    <Typography className={classes.personalLabel}>
                                        {txtMonitorBottom}
                                    </Typography>
                                </Grid>
                                <Grid item sm={12}>
                                    <Grid container>
                                        <Grid item>
                                            <Checkbox
                                                color="primary"
                                                className={classes.checkbox}
                                                checked={(props.checkBoxMonitor && props.errorAgree) ? true : false}
                                                onChange={(event) => {
                                                    if (event.target.checked) {
                                                        props.setCheckBoxMonitor(true);
                                                        props.setErrorAgree(true);
                                                    }
                                                    else {
                                                        props.setCheckBoxMonitor(false);
                                                        props.setErrorAgree(false);
                                                    }
                                                }}
                                            />
                                        </Grid>
                                        <Grid item>
                                            <Typography className={classes.installationMsgChkBox}>I am happy to move my home phone service online.</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid container sm={12} xs={12}>
                                    <Grid className={classes.errorMessageHeight}>
                                        {!props.checkBoxMonitor ?
                                            <p className={classes.errorMessage}>{validation.monitorAlarmAgreement}</p>
                                            : ''}

                                        {/* <ErrorMessage errors={errors} name="monitorAlarmAgreement">
                                            {({ message }) => <p className={classes.errorMessage}>{message}</p>}
                                        </ErrorMessage> */}

                                    </Grid>
                                </Grid>
                            </Grid>
                            : ''}
                    </Grid>
                </Paper>
            </Grid>
        </Fragment>
    );
}